/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchSortDirectionDefault = `desc`;
export const SearchSort = zod
  .object({
    direction: zod.enum(['asc', 'desc']).default(searchSortDirectionDefault),
    field: zod
      .enum(['updatedAt', 'createdAt', 'occurredAt', 'name'])
      .describe('`name` is TYPE-mode only (case-insensitive, then byte order)'),
  })
  .describe('Result order (default updatedAt desc)');

export type SearchSort = zod.input<typeof SearchSort>;
export type SearchSortOutput = zod.output<typeof SearchSort>;
